import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";import ClearIcon from '@mui/icons-material/Clear';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import React, { useEffect, useRef, useState } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import * as XLSX from 'xlsx';
import ErrorDialog from '../../../components/ErrorDialog';
import { useForm } from '../../../components/hooks/useForm';
import { getDateNow } from '../../../utils/convert';
import { Outlet, useNavigate } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';

import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Button, Grid, InputAdornment, TextField } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import { POST_SAVE_PRECIOS_MASIVOS } from '../../../data/graphQL/mutations/Insumos/mutations';
import { GET_COSTO_INSUMO_EXPORT, GET_EXISTS_COSTOINSUMO, GET_PRODUCTS } from '../../../data/graphQL/queries/Insumos/queries';
import { GET_APP_PERMISSION_BY_NOMBRE, GET_DELEGACIONES, GET_PROVEEDORES } from '../../../data/graphQL/queries/Utils/queries';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import './insumosAll.scss';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { useDebounce } from '../../../hooks/useDebounce';
import { normalizeFilterValue } from '../../../helpers/tools';
import { downloadExcel } from '../../../utils/downloadExcel';


export default function InsumosAll({ setChildrenAction }) {

  const header = ["Id", "IdInsumo", "IdDelegacion", "Delegacion", "CodigoProveedor", "Proveedor", "Costo1", "Costo2", "CostoInterno", "Iva", "Activo", "Validado", "Descripcion"];

  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];

  const [fileSelected, setFileSelected] = useState();

  const Input = styled('input')({
    display: 'none'
  });

  const [showCircular, setShowCircular] = useState(false);
  const [openDlgPrecios, setOpenDlgPrecios] = useState(false);
  const [openDlgResumen, setOpenDlgResumen] = useState(false);
  const [openConfirmacion, setOpenConfirmacion] = useState(false);

  const [permisoEscritura, setPermisoEscritura] = useState(false);

  const [anioActual, setAnioActual] = useState('');
  const [mesActual, setMesActual] = useState('');

  const [delegaciones, setDelegaciones] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [listaProcesados, setListaProcesados] = useState([]);
  const [listaNoProcesados, setListaNoProcesados] = useState([]);


  const [state, setState] = useState({
    file: {},
    data: [],
    cols: [],
    isEmpty: true
  });

  const [formValues, formHandle, reset, setFormValues] = useForm({
    Mes: '',
    Anio: ''
  });

  const [datos, setDatos] = useState('');
  const [datosOriginal, setDatosOriginal] = useState('');
  const [dataExcel, setDataExcel] = useState([]);
  const navigate = useNavigate();
  const [listadoInsumo, setListadoInsumo] = useState([]);

  const [subirArchivo, setSubirArchivo] = useState(false);

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const txtFiltro = useRef(null);
  const filterInitial = JSON.parse(localStorage.getItem('adminInsumosFilters'));
  const initialFilters = {
    activo: filterInitial != null ? filterInitial.activo : 0,
    validado: filterInitial != null ? filterInitial.validado : 0
  };

  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    getInsumos({variables: { filter: { ...filters, todos: false } }});
  }, [filters]);

  useEffect(() => {
    if (permisoEscritura) {
      setChildrenAction(() =>
      <div className='insumos-all'>
                    <CustomButton
          variant='outlined'
          className='margin-right'
          onClick={handleDownloadExcel}>
          
                        Exportar
                    </CustomButton>
                    <CustomButton
          variant='outlined'
          className='margin-right'
          title='Importar precios masivos'
          onClick={handlePreciosMasivos}>
          
                        Importar
                    </CustomButton>
                    <CustomButton
          onClick={handleNew}
          title='Agregar nuevo Insumo'
          variant='contained'>
           Nuevo
                    </CustomButton>
                </div>
      );
    }

  }, [setChildrenAction, datosOriginal, permisoEscritura]);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    if (subirArchivo)
    handleFile();
  }, [state.file]);

  useEffect(() => {
    const nombreApp = 'Insumos';
    const anioActual = getDateNow().getFullYear();
    const mesActual = getDateNow().getMonth() + 1;

    setFormValues({
      ...formValues,
      Mes: mesActual,
      Anio: anioActual
    });

    setAnioActual(anioActual);
    setMesActual(mesActual);

    getDelegaciones({ variables: { idRegion: 0 } });
    getInsumos({variables: { filter: { ...filters, todos: false } }});
    getProveedores();
    getPermisoApp({ variables: { nombreApp: nombreApp, escritura: true } });
  }, []);

  const { data: allInsumos } = useQuery(GET_PRODUCTS, {
    fetchPolicy: 'no-cache',
    variables: { filter: { todos: true, validado: 0, activo: 0 } }
  });

  useEffect(() => {
    setListadoInsumo(allInsumos?.productos?.valorEsperado);
  }, [allInsumos]);

  const [getInsumos, { error: errorInsumos, data: dataInsumos, loading: insumosLoading }] = useLazyQuery(GET_PRODUCTS, {
    fetchPolicy: 'cache-and-network',
    variables: { filter: { ...filters, todos: false } }
  });

  useEffect(() => {
    if (!dataInsumos) return;
    localStorage.setItem('adminInsumosFilters', JSON.stringify(filters));
    if (dataInsumos.productos.success) {
      const dataAll = dataInsumos.productos.valorEsperado;
      setDatos(dataAll);
      setDatosOriginal(dataAll);
      setDataExcel(dataAll);
    };
  }, [dataInsumos]);

  useEffect(() => {
    if (!errorInsumos) return;
    setMensajeError("ERRORDB");
  }, [errorInsumos]);  

  const [getPermisoApp, { error: errorPermiso, data: dataPermiso }] = useLazyQuery(GET_APP_PERMISSION_BY_NOMBRE, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataPermiso) return;
    if (dataPermiso.permisoAppByNombre.success) {
      let resultado = dataPermiso.permisoAppByNombre.valorEsperado;
      setPermisoEscritura(resultado);
    };
  }, [dataPermiso]);

  useEffect(() => {
    if (!errorPermiso) return;
    setMensajeError("ERRORDB");
  }, [errorPermiso]);    

  const [getDelegaciones, { error: errorDelegaciones, data: dataDeleg }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDeleg) return;
    if (dataDeleg.delegaciones.success) {
      setDelegaciones(dataDeleg.delegaciones.valorEsperado);
    };
  }, [dataDeleg]);

  useEffect(() => {
    if (!errorDelegaciones) return;
    setMensajeError("ERRORDB");
  }, [errorDelegaciones]);    

  const [getProveedores, { error: errorProveedores, data: dataProveedores }] = useLazyQuery(GET_PROVEEDORES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProveedores) return;
    if (dataProveedores.proveedores.success) {
      setProveedores(dataProveedores.proveedores.valorEsperado);
    };
  }, [dataProveedores]);

  useEffect(() => {
    if (!errorProveedores) return;
    setMensajeError("ERRORDB");
  }, [errorProveedores]);    

  const [getExisteCostoInsumo, { error: errorExisteCostoInsumo, data: dataExisteCostoInsumo }] = useLazyQuery(GET_EXISTS_COSTOINSUMO, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataExisteCostoInsumo) return;
    if (dataExisteCostoInsumo.existeCostoInsumo.success) {
      let existeCostoInsumo = dataExisteCostoInsumo.existeCostoInsumo.valorEsperado;
      if (!existeCostoInsumo) {
        procesarInsumos();
      } else {
        setOpenConfirmacion(true);
      }
    };
  }, [dataExisteCostoInsumo]);

  useEffect(() => {
    if (!errorExisteCostoInsumo) return;
    setMensajeError("ERRORDB");
  }, [errorExisteCostoInsumo]);    

  const [getCostoInsumosExport, { error: errorExport, data: dataExport }] = useLazyQuery(GET_COSTO_INSUMO_EXPORT, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExport) return;
    if (dataExport.costoInsumoExport.success) {
      const dataAll = dataExport.costoInsumoExport.valorEsperado;

      const data = dataAll.map((item) => {
        let obj = {
          id: item.id,
          idInsumo: item.idInsumo,
          idDelegacion: item.idDelegacion,
          delegacion: item.delegacion,
          codigoProveedor: item.cod_Proveedor,
          proveedor: item.proveedor,
          costo1: item.costo1,
          costo2: item.costo2,
          costoInterno: item.costoInterno,
          iva: item.iva,
          activo: item.activo,
          validado: item.validado,
          descripcion: item.descripcion
        };

        return obj;
      });

      const opt = 'downloadExcel Method';

      downloadExcel({
        fileName: 'ListadoInsumos',
        sheet: "Insumos",
        tablePayload: {
          header,
          body: data
        }
      });
    };
  }, [dataExport]);

  useEffect(() => {
    if (!errorExport) return;
    setMensajeError("ERRORDB");
  }, [errorExport]);  

  const [saveCostoInsumoMasivo, { dataMGuardarPreciosMasivos }] = useMutation(POST_SAVE_PRECIOS_MASIVOS, {
    onCompleted: (dataMGuardarPreciosMasivos) => {
      setShowCircular(false);
      setOpenDlgResumen(true);

      if (dataMGuardarPreciosMasivos.saveCostoInsumoMasivo.success) {
        toast.success("La lista se grabo correctamente");
      } else {
        if (dataMGuardarPreciosMasivos.saveCostoInsumoMasivo.error === 'ERRORDB' || parseInt(dataMGuardarPreciosMasivos.saveCostoInsumoMasivo.error, 10) > 0) {
          setMensajeError(dataMGuardarPreciosMasivos.saveCostoInsumoMasivo.error);
        } else
        {
          toast.error(dataMGuardarPreciosMasivos.saveCostoInsumoMasivo.error);
        }
      }
    },
    onError: (dataMGuardarPreciosMasivos) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleEdit = (row) => {
    navigate('/insumoAdmin/' + row.idInsumoN, { state: { insumo: row, edit: true, id: row.idInsumoN, listaInsumos: listadoInsumo, showGrabar: true } });
  };

  const handleView = (row) => {
    navigate('/insumoAdmin/' + row.idInsumoN, { state: { insumo: row, edit: true, id: row.idInsumoN, listaInsumos: listadoInsumo, showGrabar: false } });
  };

  const handleNew = () => {
    navigate('/insumoAdmin/0', {
      state: {
        insumo: {
          idInsumo: '',
          esSAP: false,
          idUnidad: 0,
          descripcion: '',
          idFabricante: 0,
          idTipoInsumo: '',
          descripcionGenerica: '',
          activo: true,
          presentacionComercial: '',
          idFranjaEtaria: 0,
          cantidad: '',
          peso: ''
        }, edit: false, id: 0, listaInsumos: listadoInsumo, showGrabar: true
      }
    });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const handleSearch = () => {
    if (txtFiltro.current.value != "") {
      setDatos(datosOriginal.filter((datosOriginal) => {
        const codigoBuscar = datosOriginal.idInsumo.toUpperCase();
        const DescripcionBuscar = datosOriginal.descripcion.toUpperCase();

        const inputBuscar = normalizeFilterValue(txtFiltro.current.value);
        return (
          codigoBuscar.includes(inputBuscar) || DescripcionBuscar.includes(inputBuscar));

      }
      ));
    } else {
      setDatos(datosOriginal);
    }
  };

  const handleClean = () => {
    txtFiltro.current.value = "";
    handleSearch();
    txtFiltro.current.focus();
  };

  // Precios Masivos
  function handleDownloadExcel() {
    getCostoInsumosExport();
  }

  const handlePreciosMasivos = () => {
    setOpenDlgPrecios(true);
  };

  const isFormValid = () => {
    if (state.data.length <= 0) {
      toast.error('Debe seleccionar un archivo');
      return false;
    }

    let anio = parseInt(formValues.Anio);
    let mes = parseInt(formValues.Mes);

    if (anio < anioActual || anio === anioActual && mes <= mesActual) {
      return true;
    } else
    {
      toast.error('No se puede procesar el período seleccionado');
      return false;
    }
  };

  const handleAceptarPrecios = () => {
    if (isFormValid())
    getExisteCostoInsumo({ variables: { mes: parseInt(formValues.Mes), anio: parseInt(formValues.Anio) } });
  };

  const handleAceptarDlg = () => {
    setOpenConfirmacion(false);
    procesarInsumos();
  };

  const handleCancelarDlg = () => {
    setOpenConfirmacion(false);
  };

  const procesarInsumos = () => {
    setOpenDlgPrecios(false);
    setShowCircular(true);

    try {

      const listaCostosInsumo = state.data.map((item) => {

        let insumo = datos.find((x) => x.idInsumoN === item.Id);
        let delegacion = delegaciones.find((x) => x.idDelegacion === item.IdDelegacion);
        let existeProveedor = false;
        let noProcesarDelegacion = false;

        // validar proveedor
        if (item.CodigoProveedor) {
          let proveedor = proveedores.find((x) => x.cod_Proveedor == item.CodigoProveedor.toString().padStart(10, '0'));
          existeProveedor = proveedor;
        }

        // validar delegacion
        if (item.IdDelegacion === 1) {
          let global = state.data.filter((x) => x.Id === item.Id && (x.IdDelegacion != 1 || x.IdDelegacion === item.IdDelegacion));
          noProcesarDelegacion = global.length > 1;
        } else
        {
          let local = state.data.filter((x) => x.Id === item.Id && x.IdDelegacion === 1);
          noProcesarDelegacion = local.length > 0;
        }

        let obj = '';
        if (insumo && (delegacion || item.IdDelegacion === 1) && existeProveedor && !noProcesarDelegacion) {
          obj = {
            anio: parseInt(formValues.Anio),
            cod_Proveedor: item.CodigoProveedor ? item.CodigoProveedor.toString().padStart(10, '0') : '',
            costo1: parseFloat(item.Costo1),
            costo2: parseFloat(item.Costo2),
            costoInterno: parseFloat(item.CostoInterno),
            delegacion: item.Delegacion ? item.Delegacion.toString() : '',
            idCostoInsumo: 0,
            idDelegacion: parseInt(item.IdDelegacion),
            idInsumoN: parseInt(item.Id),
            idInsumo: item.IdInsumo,
            descripcion: item.Descripcion,
            iva: parseFloat(item.Iva),
            mes: parseInt(formValues.Mes),
            proveedor: item.Proveedor ? item.Proveedor.toString() : ''
          };
        } else
        {
          obj = {
            anio: parseInt(formValues.Anio),
            cod_Proveedor: item.CodigoProveedor ? item.CodigoProveedor.toString().padStart(10, '0') : '',
            costo1: parseFloat(item.Costo1),
            costo2: parseFloat(item.Costo2),
            costoInterno: parseFloat(item.CostoInterno),
            delegacion: item.Delegacion ? item.Delegacion.toString() : '',
            idCostoInsumo: -1,
            idDelegacion: parseInt(item.IdDelegacion),
            idInsumoN: parseInt(item.Id),
            idInsumo: item.IdInsumo,
            descripcion: item.Descripcion,
            iva: parseFloat(item.Iva),
            mes: parseInt(formValues.Mes),
            proveedor: item.Proveedor ? item.Proveedor.toString() : ''
          };
        }

        return obj;

      });

      let insumosProcesar = listaCostosInsumo.filter((x) => x.idCostoInsumo != -1 &&
      !isNaN(x.costo1) && x.costo1 >= 0 &&
      !isNaN(x.costo2) && x.costo2 >= 0 &&
      !isNaN(x.costoInterno) && x.costoInterno >= 0 &&
      !isNaN(x.iva) && x.iva >= 0);

      let insumosNoProcesar = listaCostosInsumo.filter((x) => x.idCostoInsumo === -1 ||
      isNaN(x.costo1) || x.costo1 < 0 ||
      isNaN(x.costo2) || x.costo2 < 0 ||
      isNaN(x.costoInterno) || x.costoInterno < 0 ||
      isNaN(x.iva) || x.iva < 0);

      setListaProcesados(insumosProcesar);
      setListaNoProcesados(insumosNoProcesar);

      let listaCostoInsumos = insumosProcesar.map((item) => {
        let obj = '';
        obj = {
          anio: item.anio,
          cod_Proveedor: item.cod_Proveedor,
          costo1: item.costo1,
          costo2: item.costo2,
          costoInterno: item.costoInterno,
          delegacion: item.delegacion,
          idCostoInsumo: item.idCostoInsumo,
          idDelegacion: item.idDelegacion,
          idInsumo: item.idInsumoN,
          iva: item.iva,
          mes: item.mes,
          proveedor: item.proveedor
        };

        return obj;
      });

      saveCostoInsumoMasivo({ variables: { listaCostosInsumos: listaCostoInsumos } });

    } catch (e) {
      toast.error('Se produjo un error al intentar procesar el archivo');
      console.log(e);
    }

    limpiarPopUp();
  };

  const handleCloseDlgPrecios = () => {
    setOpenDlgPrecios(false);
    limpiarPopUp();
  };

  const make_cols = (refstr) => {
    let o = [],C = XLSX.utils.decode_range(refstr).e.c + 1;
    for (var i = 0; i < C; ++i) o[i] = { name: XLSX.utils.encode_col(i), key: i };
    return o;
  };

  const limpiarPopUp = () => {
    setState((prevState) => {
      return {
        ...prevState,
        file: {},
        data: [],
        cols: [],
        isEmpty: true
      };
    });
  };

  const handleCloseDlgResumen = () => {
    setOpenDlgResumen(false);
  };

  const initialColumnsExcel = [
  {
    field: 'IdInsumo',
    headerName: 'Insumo'
  },
  {
    field: 'IdDelegacion',
    headerName: 'IdDelegacion'
  },
  {
    field: 'Delegacion',
    headerName: 'Delegacion'
  },
  {
    field: 'CodigoProveedor',
    headerName: 'Codigo Proveedor'
  },
  {
    field: 'Proveedor',
    headerName: 'Proveedor'
  },
  {
    field: 'Costo1',
    headerName: 'Costo 1'
  },
  {
    field: 'Costo2',
    headerName: 'Costo 2'
  },
  {
    field: 'CostoInterno',
    headerName: 'Costo Interno'
  },
  {
    field: 'Iva',
    headerName: 'Iva'
  }];


  const columnsExcel = generateColumnsDefaultConfiguration(initialColumnsExcel);

  const initialColumnsProcesamiento = [
  {
    field: 'idInsumoN',
    headerName: 'Insumo'
  },
  {
    field: 'idInsumo',
    headerName: 'IdInsumo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripcion'
  },
  {
    field: 'idDelegacion',
    headerName: 'IdDelegacion'
  },
  {
    field: 'delegacion',
    headerName: 'Delegacion'
  },
  {
    field: 'cod_Proveedor',
    headerName: 'Codigo Proveedor'
  },
  {
    field: 'proveedor',
    headerName: 'Proveedor'
  },
  {
    field: 'costo1',
    headerName: 'Costo 1'
  },
  {
    field: 'costo2',
    headerName: 'Costo 2'
  },
  {
    field: 'costoInterno',
    headerName: 'Costo Interno'
  },
  {
    field: 'iva',
    headerName: 'Iva'
  }];


  const columnsProcesamiento = generateColumnsDefaultConfiguration(initialColumnsProcesamiento);

  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (params) => {
      return (
        <>
                        <PopoverModal>
                            <div className='popover-modal-content'>
                                {
              permisoEscritura &&
              <div onClick={() => handleEdit(params.row)} aria-hidden='true'
              className='item-option clickable-option'>
                
                                        <EditIcon className='edit-icon' />
                                        <span className='toggle-action'>Editar</span>
                                    </div>
              }

                                <div onClick={() => handleView(params.row)} aria-hidden='true'
              className='item-option'>
                
                                    <VisibilityIcon className='edit-icon' />
                                    <span className='toggle-action'>Ver</span>
                                </div>
                            </div>
                        </PopoverModal>
                    </>);

    }
  },
  {
    field: 'idInsumo',
    headerName: 'Insumo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripción',
    flex: 0.4
  },
  {
    field: 'presentacion',
    headerName: 'Presentación',
    flex: 0.2
  },
  {
    field: 'cantXPack',
    headerName: 'Cantidad',
    flex: 0.09
  },
  {
    field: 'activo',
    type: 'boolean',
    headerName: 'Activo',
    headerAlign: 'center',
    align: 'center',
    flex: 0.1,
    renderCell: (params) => {
      return params.value ?
      <CheckIcon
        className='icon-grid' /> :

      "";
    }
  },
  {
    field: 'validado',
    type: 'boolean',
    headerName: 'Validado',
    headerAlign: 'center',
    align: 'center',
    flex: 0.1,
    renderCell: (params) => {
      return params.value ?
      <CheckIcon
        className='icon-grid' /> :

      "";
    }
  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  const handleChange = (e) => {
    setSubirArchivo(true);

    const files = e.target.files;
    setFileSelected(files[0].type);

    if (files && files[0])
    setState((prevState) => {
      return {
        ...prevState,
        file: files[0]
      };
    });
  };

  const isValidTipoArchivo = () => {
    return FILE_TYPE.some((e) => e === fileSelected);
  };

  const handleFile = () => {
    try {

      if (isValidTipoArchivo()) {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;

        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_json(ws);
          /* Update state */

          setState((prevState) => {
            return {
              ...prevState,
              data: data,
              make_cols: make_cols(ws['!ref']),
              isEmpty: false
            };
          });
        };

        if (rABS) {
          reader.readAsBinaryString(state.file);
        } else {
          reader.readAsArrayBuffer(state.file);
        };
      } else
      {
        toast.error("El tipo de archivo adjunto no está permitido.");
      }
    } catch (e) {
      console.log("Empty!");
    }
  };

  return (
    <>
            <div className='general-container'>
                <div className='action-row'>
                    <TextField
            className="input-300"
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtFiltro}
            onKeyUp={handleSearch}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
              <InputAdornment position="end">
                                    <SearchIcon
                  onClick={handleSearch}
                  sx={{ cursor: 'pointer' }} />
                
                                    <ClearIcon
                  onClick={handleClean}
                  sx={{ cursor: 'pointer' }} />
                
                                </InputAdornment>

            }} />
          
                    <div className='button-group-container'>
                        <ButtonOptionGroup
              options={['Activos', 'Inactivos', 'Todos']}
              onOptionClick={(e) => setFilters({
                ...filters,
                activo: e
              })}
              selectedOption={filters?.activo} />
            
                    </div>
                    <div className='button-group-container'>
                        <ButtonOptionGroup
              options={['Validados', 'No Validados', 'Todos']}
              onOptionClick={(e) => setFilters({
                ...filters,
                validado: e
              })}
              selectedOption={filters?.validado} />
            
                    </div>
                </div>
            </div>

            <DataGridGenerico
        columns={columns}
        loading={insumosLoading}
        fileNameExport='Insumos'
        rows={datos}
        toolbar={false} />
      
            <Outlet />

            <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      


            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgPrecios}
        title={'Carga de precios masivos'}
        onAccept={handleAceptarPrecios}
        onCancel={handleCloseDlgPrecios}
        cancelText='Cerrar'>
        
                <Grid
          container
          spacing={0}
          direction="row"
          alignItems="left"
          justifyContent="left">
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '0%' }} size={{ xs: 12, md: 6, lg: 4 }}>
                        <TextField
              className="input-300"
              label="Mes"
              name="Mes"
              onChange={formHandle}
              size="small"
              type="number"
              value={formValues.Mes}
              variant="outlined"
              InputProps={{ inputProps: { min: 1, max: 12 } }} />
            
                    </Grid>
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '0%' }} size={{ xs: 12, md: 6, lg: 4 }}>
                        <TextField
              className="input-300"
              label="Año"
              name="Anio"
              onChange={formHandle}
              size="small"
              type="number"
              value={formValues.Anio}
              variant="outlined" />
            
                    </Grid>
                    <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '0%' }} size={{ xs: 12, md: 6, lg: 4 }}>
                        <label htmlFor="icon-button-file">
                            <Input accept="xlsx/xls" onChange={handleChange} id="icon-button-file" type="file" />
                            <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                <CloudUploadIcon fontSize="inherit" />
                            </IconButton>
                        </label>
                    </Grid>
                </Grid>
                <DataGridGenerico
          columns={columnsExcel}
          rows={state.data}
          toolbar={false} />
        
            </CustomDialog>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgResumen}
        title={'Resúmen Procesamiento'}
        onCancel={handleCloseDlgResumen}
        cancelText='Cerrar'>
        
                <h4>Insumos Procesados:</h4>
                <DataGridGenerico
          columns={columnsProcesamiento}
          rows={listaProcesados}
          fileNameExport='InsumosProcesados'
          toolbar={true} />
        
                <h4>Insumos No Procesados:</h4>
                <DataGridGenerico
          columns={columnsProcesamiento}
          rows={listaNoProcesados}
          fileNameExport='InsumosNoProcesados'
          toolbar={true} />
        
            </CustomDialog>

            <CustomDialog
        maxWidth="md"
        open={openConfirmacion}
        title={'Confirmación de modificación'}
        onCancel={handleCancelarDlg}
        onAccept={handleAceptarDlg}>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ fontSize: '11pt' }}>
                        <strong>¿Está seguro de procesar la carga de precios masivos?. </strong>
                        <br /><br />
                        Ya existe al menos un precio cargado para el periodo <strong>{formValues.Mes}/{formValues.Anio}</strong>.
                        <br /><br />
                        Pulse <strong>Aceptar</strong> en caso de confirmar los cambios o <strong>Cancelar</strong> en caso contrario.
                    </div>
                </div>
            </CustomDialog>

            {showCircular &&
      <div class="loadingFullPage">
                    <div><CircularProgress disableShrink /><br />Cargando...</div>
                </div>
      }

        </>);

}